import * as React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, TextField, DialogActions, Button } from '@mui/material';
import { Modal, Form, Input, Switch, Divider } from 'antd';
// import { PlusOutlined } from '@ant-design/icons';
import 'antd/dist/antd.css';

import { CategoriesContext } from '../context/CategoriesContext';

export default function CategoryModal() {
  const { editModal, setEditModal, editCategory, editCategorySubmit } = React.useContext(CategoriesContext);
  const [title, setTitle] = React.useState('');
  const [form] = Form.useForm();
  const { TextArea } = Input;

  const formItemLayout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 16,
    },
  };
  React.useEffect(() => {
    if (typeof editCategory.id === 'undefined') {
      form.resetFields();
      setTitle('Add new Category');
      form.setFieldsValue(editCategory);
    } else {
      form.resetFields();
      setTitle('Edit Category');
      form.setFieldsValue(editCategory);
      // console.log(form.getFieldValue('skuImageFiles'), 'when set field value call');
    }
  }, [editCategory]);

  const handleClose = () => {
    form.resetFields();
    setEditModal(false);
  };

  return (
    <Dialog open={editModal} onClose={handleClose} fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <Form name='edit_categories' form={form} {...formItemLayout} onFinish={editCategorySubmit}>
        <DialogContent>
          <Form.Item name='parentId' label='ParentId' hidden>
            <Input placeholder='parentId' disabled />
          </Form.Item>
          <Form.Item name='parent_name' label='Parent Category'>
            <Input placeholder='parent' disabled />
          </Form.Item>
          <Form.Item name='name' label='Category Name'>
            <Input showCount placeholder='name' />
          </Form.Item>
          <Form.Item name='description' label='รายละเอียด'>
            <TextArea placeholder='ราคาปกติ' rows={5} />
          </Form.Item>
          <Form.Item name='slug' label='slug url'>
            <Input placeholder='/slug-name' />
          </Form.Item>
          <Divider />
          <Form.Item
            wrapperCol={{
              span: 6,
              offset: 10,
            }}
            style={{ marginBottom: 0 }}>
            <Button type='submit' color='primary' variant='contained'>
              Save
            </Button>
          </Form.Item>
        </DialogContent>
      </Form>
    </Dialog>
  );
}
